function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-three-section-slider\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.74,27.19H13.26a1.13,1.13,0,1,1,0-2.25H26.74a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.74,32.23H13.26a1.13,1.13,0,1,1,0-2.25H26.74a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.46,20.83H14.54a2.42,2.42,0,0,1-2.41-2.42V11a2.41,2.41,0,0,1,2.41-2.41H25.46A2.41,2.41,0,0,1,27.87,11v7.46A2.42,2.42,0,0,1,25.46,20.83Zm-10.92-10a.16.16,0,0,0-.16.16v7.46a.17.17,0,0,0,.16.17H25.46a.17.17,0,0,0,.16-.17V11a.16.16,0,0,0-.16-.16Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.26,23.7a.86.86,0,0,1-.5-.17l-3.7-2.74A1,1,0,0,1,.68,20a1,1,0,0,1,.38-.8l3.69-2.73a.85.85,0,0,1,1.18.17.85.85,0,0,1-.18,1.18L2.81,20l2.95,2.18a.84.84,0,0,1,.17,1.18A.82.82,0,0,1,5.26,23.7ZM2.05,19.44h0Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.74,23.7a.84.84,0,0,1-.5-1.52L37.19,20l-2.94-2.18a.85.85,0,0,1-.18-1.18.85.85,0,0,1,1.18-.17l3.69,2.73a1,1,0,0,1,.38.8,1,1,0,0,1-.38.79l-3.7,2.74A.86.86,0,0,1,34.74,23.7Zm3.2-3.15h0Z",
  fill: "#231f20"
});

function SvgCmsThreeSectionSlider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgCmsThreeSectionSlider;